(() => {
  class ArmoniaUnifiedHero extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.on = (target, event, listener) => target?.addEventListener(event, listener, {signal:this.abort.signal});
      const fitBackground = () => {
        const nativeWidth = Number(this.dataset.nativeWidth) || 1672;
        this.style.setProperty('--p14-raster-width', `${nativeWidth / Math.max(1,window.devicePixelRatio || 1)}px`);
      };
      fitBackground();
      this.on(window,'resize',fitBackground);
      this.rotator = this.querySelector('[data-spotlight-rotator]');
      this.track = this.querySelector('.p14-spotlight__cards');
      this.cards = [...this.querySelectorAll('[data-spotlight-card]')];
      if (!this.track || !this.cards.length) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true';
      this.hovered = false;
      this.focused = false;
      this.inView = true;
      this.delay = Math.max(5000, Number(this.dataset.interval) || 5000);
      const dots = this.querySelector('[data-bs-dots]');
      dots.replaceChildren();
      this.cards.forEach((card, i) => {
        card.hidden = false;
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Mostra ${card.dataset.title}`);
        this.on(dot, 'click', () => this.go(i, true));
        dots.append(dot);

      });
      this.dots = [...dots.children];
      this.rotator.dataset.bsReady = 'true';
      this.querySelector('.p14-nav').hidden = this.cards.length < 2;
      this.on(this.querySelector('[data-bs-prev]'), 'click', () => this.go(this.index-1, true));
      this.on(this.querySelector('[data-bs-next]'), 'click', () => this.go(this.index+1, true));
      this.on(this.querySelector('[data-bs-pause]'), 'click', () => {this.paused=!this.paused;this.updatePause();this.schedule();});
      this.on(this.rotator, 'keydown', e => {
        if (!['ArrowLeft','ArrowRight'].includes(e.key)) return;
        e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1), true);
      });
      let touch;
      this.on(this.track, 'touchstart', e => {touch={x:e.touches[0].clientX,y:e.touches[0].clientY};clearTimeout(this.timer);});
      this.on(this.track, 'touchend', e => {
        if(!touch)return;
        const dx=e.changedTouches[0].clientX-touch.x,dy=e.changedTouches[0].clientY-touch.y;
        if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.5)this.go(this.index+(dx<0?1:-1),true);
        touch=null;this.schedule();
      });
      this.on(this.track,'touchcancel',()=>{touch=null;this.schedule();});
      this.on(this.rotator, 'pointerenter', e => {if(e.pointerType!=='touch'){this.hovered=true;this.schedule();}});
      this.on(this.rotator, 'pointerleave', () => {this.hovered=false;this.schedule();});
      this.on(this.rotator, 'focusin', () => {this.focused=true;this.schedule();});
      this.on(this.rotator, 'focusout', () => queueMicrotask(() => {if(this.abort){this.focused=this.rotator.contains(document.activeElement);this.schedule();}}));
      this.on(document, 'visibilitychange', () => this.schedule());
      this.on(this.motion, 'change', () => {this.updatePause();this.schedule();});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {this.inView=entries[0].isIntersecting;this.schedule();});
        this.observer.observe(this.rotator);
      }
      this.update(0);this.updatePause();this.schedule();
    }
    go(index, announce=false) {
      const next=(index+this.cards.length)%this.cards.length;

      this.update(next);
      if(announce) this.querySelector('[data-bs-status]').textContent=this.cards[next].dataset.title;
      this.schedule();
    }
    update(index) {
      this.index=index;
      this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
      // Only one complete product exists in the visual flow; no overlapping fades.
      this.cards.forEach((card,i)=>{
        const active=i===index;
        card.hidden=!active;
        card.inert=!active;
        card.dataset.active=String(active);
        card.setAttribute('aria-hidden',String(!active));
      });
      this.querySelector('[data-bs-count]').textContent=`${String(index+1).padStart(2,'0')} / ${String(this.cards.length).padStart(2,'0')}`;
    }
    updatePause() {
      const button=this.querySelector('[data-bs-pause]');
      const stopped=this.paused||this.motion.matches;
      button.textContent=stopped?'▶':'Ⅱ';
      button.disabled=this.motion.matches;
      button.setAttribute('aria-label',stopped?'Avvia i bestseller':'Metti in pausa i bestseller');
    }
    schedule() {
      clearTimeout(this.timer);
      if(!this.abort||this.cards.length<2||this.paused||this.motion.matches||this.hovered||this.focused||!this.inView||document.hidden) return;
      this.timer=setTimeout(()=>this.go(this.index+1),this.delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);clearTimeout(this.scrollTimer);
      this.observer?.disconnect();this.abort?.abort();this.abort=null;
    }
  }
  if (!customElements.get('armonia-premium-hero')) customElements.define('armonia-premium-hero',ArmoniaUnifiedHero);
})();
